import { Route, Routes, Navigate } from "react-router-dom";
import Register from "./components/Register";
import Login from "./components/Login";
import Hub from "./components/Hub";
// import HubNew from "./components/HubNew";
import IndEvent from "./components/IndEvent"
import Guestiis from "./components/Guestiis";
import Team from "./components/Team";
import TeamVerify from "./components/TeamVerify";
import AuthAuthenticating from "./components/Auth/Authenticating";


function App() {
	return (
		<Routes>
			<Route path="/connect" exact element={<Login />} />
			{/* <Route path="/register" exact element={<Register />} /> */}
			<Route path="/auth/google-callback" exact element={<AuthAuthenticating />} />
			<Route path="/team-verify/:roleId/:userId/:token" exact element={<TeamVerify />} />

			<Route path="/hub/:_id" exact element={<Hub />} />
			<Route path="/hub/:_id/:event_id" exact element={<IndEvent />} />
			<Route path="/guestiis/:_id" exact element={<Guestiis />} />
			<Route path="/team/:_id" exact element={<Team />} />

			<Route path="/" element={<Navigate replace to="/connect" />} />
		</Routes>
	);
}

export default App;
